import { motion } from 'framer-motion';

interface PageLoaderProps {
  message?: string;
}

const PageLoader = ({ message = 'Loading...' }: PageLoaderProps) => {
  return (
    <div className="min-h-[60vh] flex items-center justify-center bg-gradient-to-br from-ivory-50 to-ivory-100 py-20">
      <div className="text-center">
        {/* Animated Yoga Symbol */}
        <motion.div
          className="mb-8"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
        >
          <motion.div
            className="text-5 mb-4"
            animate={{
              rotate: [0, 10, -10, 10, 0],
              scale: [1, 1.1, 1, 1.1, 1],
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut',
            }}
          >
            🧘
          </motion.div>
        </motion.div>

        {/* Spinner */}
        <motion.div
          className="relative mx-auto mb-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          <div className="w-16 h-16 md:w-20 md:h-20 border-4 border-ivory-200 border-t-primary rounded-full relative">
            <motion.div
              className="absolute inset-0 border-4 border-transparent border-t-accent rounded-full"
              animate={{ rotate: 360 }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                ease: 'linear',
              }}
              style={{ clipPath: 'polygon(0 0, 50% 0, 50% 100%, 0 100%)' }}
            />
          </div>
        </motion.div>

        {/* Loading Text */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
        >
          <p className="text-ivory-700 font-medium text-4 md:text-5 mb-2">
            {message}
          </p>
          <div className="flex items-center justify-center space-x-1">
            <motion.span
              animate={{ opacity: [0.3, 1, 0.3] }}
              transition={{ duration: 1.5, repeat: Infinity, delay: 0 }}
              className="text-primary text-5"
            >
              •
            </motion.span>
            <motion.span
              animate={{ opacity: [0.3, 1, 0.3] }}
              transition={{ duration: 1.5, repeat: Infinity, delay: 0.2 }}
              className="text-primary text-5"
            >
              •
            </motion.span>
            <motion.span
              animate={{ opacity: [0.3, 1, 0.3] }}
              transition={{ duration: 1.5, repeat: Infinity, delay: 0.4 }}
              className="text-primary text-5"
            >
              •
            </motion.span>
          </div>
        </motion.div>

        {/* Decorative Elements */}
        <motion.div
          className="absolute inset-0 pointer-events-none"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
        >
          <div className="absolute top-20 left-10 text-5 text-primary/10">
            🕉️
          </div>
          <div className="absolute bottom-20 right-10 text-5 text-primary/10">
            🪷
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default PageLoader;


